import { customerRoutes } from 'noddi-util';

export const carStepPath = customerRoutes.newBookingCars.getPath();
export const salesItemStepPath = customerRoutes.newBookingPrimaryItems.getPath();
export const tireHotelCancelStepPath = customerRoutes.newBookingCancelTireHotel.getPath();
export const tireHotelPickupStepPath = customerRoutes.newBookingTireHotel.getPath();
export const addonsStepPath = customerRoutes.newBookingAddons.getPath();
export const timeWindowStepPath = customerRoutes.newBookingTimeWindow.getPath();
export const summaryStepPath = customerRoutes.newBookingSummary.getPath();
